import { memo } from 'react'
import useTabAlreadyOpen from 'hooks/useTabAlreadyOpen'
import { AnimatePresence } from 'framer-motion'
import { ROUTES } from 'Constants'
import styled from 'styled-components'
import { background } from 'styles/Colors'
import { useLocation } from 'react-router-dom'
import AccountContent from 'components/account/Content'
import { AccountSectionProvider } from 'components/account/context'
import OtherTabOpen from './OtherTabOpen'
import TopBar from './TopBar'
import Sidebar from './Sidebar'


export const Container = styled.div`
  background-color: ${background};
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  display: flex;
`

const AccountPage = () => {
  const otherTabOpen = useTabAlreadyOpen()
  const location = useLocation()

  if (otherTabOpen) {
    return (
      <Container>
        <OtherTabOpen />
      </Container>
    )
  }
  return (
    <AccountSectionProvider>
      <div className="w-screen h-screen overflow-hidden flex ">
        <div className="w-3/4 h-full">
          <TopBar />
        
          <AnimatePresence>
            <AccountContent />
          </AnimatePresence>
        </div>
        <div className="w-1/4 h-full border-l border-grey-100">
          <Sidebar />
        </div>
      </div>
    </AccountSectionProvider>
  )
}

AccountPage.whyDidYouRender = true

export default memo(AccountPage)
